import React from 'react'

const ModalHeaderId = ({ idText, text }) => {
  return (
    <div id={idText} className='ant-modal-title'>{text}</div>
  )
}

export default ModalHeaderId
